import React, { useState } from "react";
import { Image, Spinner } from "react-bootstrap";
import { useUser } from "../context/UserProvider";
import { LoginButton } from "./Buttons/LoginButton";
import { SubscribeButton } from "./Buttons/SubscribeButton";

export const UserInfoCard: React.FC = () => {
  const { user, setUser } = useUser();
  const [loggingOut, setLoggingOut] = useState(false);

  const logout = () => {
    setLoggingOut(true);
    setTimeout(() => {
      setUser(null, "");
      setLoggingOut(false);
    }, 1000); // 1-second delay to simulate logout UX
  };

  return (
    <>
      {user ? (
        <>
          <SubscribeButton user={user}/>
        <span
          onClick={!loggingOut ? logout : undefined}
          className="google-login-button d-inline-flex align-items-center"
          style={{ cursor: loggingOut ? "not-allowed" : "pointer", opacity: loggingOut ? 0.6 : 1 }}
        >
          {loggingOut ? (
            <Spinner animation="border" size="sm" className="me-2" />
          ) : (
            <Image
              roundedCircle
              src={user.ProfilePicture}
              alt="Profile"
              style={{ width: '21px', height: '21px', margin: 0, padding: 0 }}
            />
          )}
          <span className="d-none d-sm-inline ms-2">
            {loggingOut ? "Logging out..." : "Logout"}
          </span>
        </span>
        </>
      ) : (
          <LoginButton />
      )}
    </>
  );
};
